
import React from "react";
import "./PageStyles.css";

function NotFound() {
  return (
    <div className="page">
      <h1>404 - Page Not Found</h1>
      <p>Oops! The page you’re looking for doesn’t exist.</p>
    </div>
  );
}

export default NotFound;
